import { object, string, number } from "yup";
import i18next from "/app/src/locales/config";

export const criteriaSchema = object({
  reportId: string().required(i18next.t("translation:required")),
  verb: string().required(i18next.t("translation:required")),
  value: number().required(i18next.t("translation:required")),
});
